<template>
    <div style="text-align: right;min-height:115px;" 
        :style="{ 'visibility': totalPrice === 0 ? 'hidden' : 'visible' }">
        <template v-if="!noOptionsReservation">
        <p v-for="(obj, key) in priceClasses" 
           v-bind:key="key">
            {{ obj.quantity * (activeReservation.recurringDates.length + 1) }}
            {{ $_locale('pieces', false) }} á
            {{ key }}
            {{ $_CURRENCY_SYMBOL }}
        </p>
        </template>
        <p style="font-weight: bold;">
            {{ $_locale('total') }}: 
            {{ $_formatCurrency(totalPrice) }}
            {{ $_CURRENCY_SYMBOL }}
        </p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        additionalReservations: {
            type: Array,
            required: true,
            default: () => [],
        }
    },
    computed: {
        ...mapGetters({
            adminMode: 'common/adminMode',
            activeReservation: 'calendar/activeReservation',
            availableAdditionalResources: 'calendar/availableAdditionalResources',
            additionalResourceQuantity: 'calendar/additionalResourceQuantity',
            settings: 'reservations/settings',
            selectedPlayers: 'golf/selectedPlayers',
            userPlayer: 'golf/userPlayer',
            allPlayerPrices: 'golf/allPlayerPrices',
        }),
        // when minDuration and maxDuration is the same
        // there are only one option to choose
        noOptionsReservation() {
            return this.settings.minDuration === this.settings.maxDuration;
        },
        resourceQuantity() {
            return (resourceId) =>  {
                return this.additionalResourceQuantity[resourceId] || 0;
            }
        },
        selectedAdditionalResources() {
            return this.availableAdditionalResources
                .map((resource) => {
                    resource.orderQuantity = this.additionalResourceQuantity[resource.resourceId] || 0;
                    return resource;
                })
                .filter(
                    (resource) => resource.orderQuantity > 0 && !!resource.productPrice
                )
        },
        totalPrice() {
            //let price = this.activeReservation.price * this.activeReservation.orderQuantity;
            let price = this.playerPrices.reduce((acc, curr) => acc + curr.price, 0);
            
            if (this.additionalReservations.length > 0) {
                this.additionalReservations.forEach((resObj) => {
                    price += resObj.price;
                })
            }

            if (!this.activeReservation.recurringReservation 
                    && this.availableAdditionalResources.length > 0) {
                const additionalResources = this.selectedAdditionalResources;

                additionalResources.forEach((resource) => {
                    let productPrice = -(-resource.productPrice);

                    if (resource.productType === 6) {
                        productPrice = -(-resource.productPrice) * (resource.productReservationMinDuration / resource.productReservationDuration)
                    }

                    price += productPrice * resource.orderQuantity;
                })
            }

            return price * (this.activeReservation.recurringDates.length + 1);
        },
        additionalReservationsPriceClasses() {
            const priceClasses = {};
            
            if (this.additionalReservations.length === 0) {
                return priceClasses;
            }
            
            this.additionalReservations.forEach((resObj) => {   
                const { availableBlocks, selectedIndex, aPrice, quantity } = resObj;
                const selectedBlocks = availableBlocks.slice(0, selectedIndex + 1);
                const key = aPrice;
                
                if (typeof priceClasses[key] !== 'undefined') {
                    priceClasses[key].quantity += quantity;
                    priceClasses[key].blocks = [
                        ...priceClasses[key].blocks,
                        ...selectedBlocks,
                    ];
                } else {
                    priceClasses[key] = {
                        quantity,
                        blocks: selectedBlocks
                    }
                }
            })
            
            return priceClasses;
        },
        additionalResourcesPriceClasses() {
            const additionalResources = this.selectedAdditionalResources;
            const priceClasses = {};
            
            if (this.activeReservation.recurringReservation 
                    || this.availableAdditionalResources.length === 0
                    || additionalResources.length === 0) {
                return priceClasses;
            }
            
            additionalResources.forEach((resource) => {
                const blocks = Array(resource.orderQuantity).fill({
                    price: -(-resource.productPrice),
                    resource: resource
                });
                const obj = {
                    quantity: resource.orderQuantity,
                    blocks,
                };
                let key = -(-resource.productPrice);

                if (resource.productType === 6) {
                    key = -(-resource.productPrice) * (resource.productReservationMinDuration / resource.productReservationDuration)
                }
                
                if (typeof priceClasses[key] !== 'undefined') {
                    priceClasses[key].quantity += obj.quantity;
                    priceClasses[key].blocks = [
                        ...priceClasses[key].blocks,
                        ...obj.blocks,
                    ];
                } else {
                    priceClasses[key] = obj;
                }
            })
            
            return priceClasses;
        },
        playerPrices() {
            const golfPlayers = [
                ...this.selectedPlayers
            ]

            if (!this.adminMode) {
                golfPlayers.unshift(this.userPlayer)
            }
            
            return golfPlayers.map(player => {
                const priceObj = this.allPlayerPrices.filter(row => row.personId === player.personId)[0];
                
                if (!priceObj) return { price: 0, personId: null };

                return priceObj;
            })
        },
        playerClasses() {
            const priceClasses = {};
            const playerPrices = this.playerPrices;
            
            playerPrices.forEach(row => {
                const key = row.price;
                const blocks = Array(1).fill({
                    price: row.price,
                    resource: row
                });
                const obj = {
                    quantity: 1,
                    blocks,
                };

                if (typeof priceClasses[key] !== 'undefined') {
                    priceClasses[key].quantity += obj.quantity;
                    priceClasses[key].blocks = [
                        ...priceClasses[key].blocks,
                        ...obj.blocks,
                    ];
                } else {
                    priceClasses[key] = obj;
                }
            })

            return priceClasses;
        },
        priceClasses() {
            const priceClasses = JSON.parse(JSON.stringify(this.activeReservation.priceClasses)); // deep copy
            const additionalResources = this.additionalResourcesPriceClasses;
            const additionalReservations = this.additionalReservationsPriceClasses;
            const playerClasses = this.playerClasses;
            
            Object.keys(additionalResources).forEach(key => {
                const obj = additionalResources[key];
                
                if (typeof priceClasses[key] !== 'undefined') {
                    priceClasses[key].quantity += obj.quantity;
                    priceClasses[key].blocks = [
                        ...priceClasses[key].blocks,
                        ...obj.blocks,
                    ];
                } else {
                    priceClasses[key] = { ...obj };
                }
            })
            
            Object.keys(additionalReservations).forEach(key => {
                const obj = additionalReservations[key];
                
                if (typeof priceClasses[key] !== 'undefined') {
                    priceClasses[key].quantity += obj.quantity;
                    priceClasses[key].blocks = [
                        ...priceClasses[key].blocks,
                        ...obj.blocks,
                    ];
                } else {
                    priceClasses[key] = { ...obj };
                }
            })

            Object.keys(playerClasses).forEach(key => {
                const obj = playerClasses[key];
                
                if (typeof priceClasses[key] !== 'undefined') {
                    priceClasses[key].quantity += obj.quantity;
                    priceClasses[key].blocks = [
                        ...priceClasses[key].blocks,
                        ...obj.blocks,
                    ];
                } else {
                    priceClasses[key] = { ...obj };
                }
            })
            
            return priceClasses;
        },
        
    },
    methods: {
        getTotalPrice() {
            return this.totalPrice;
        },
        getPlayerClasses() {
            return this.playerClasses;
        },
        getPlayerRows() {
            const playerPrices = this.playerPrices;
        }
    }
}
</script>